import styled from 'styled-components'

const TABLET_BREAKPOINT = '930px'

const statBorderColor = color => {
    if (color === 'purple') return '#8b5cf6'
    if (color === 'green') return '#10b981'
    if (color === 'blue') return '#2563eb'
    if (color === 'orange') return '#f97316'
    return '#9ca3af'
}

const stepNumBg = p => {
    if (p.$active) return '#2563eb'
    if (p.$done) return '#10b981'
    return '#e5e7eb'
}

const stepLabelColor = p => {
    if (p.$active) return '#2563eb'
    if (p.$done) return '#047857'
    return '#6b7280'
}

const qPickBg = p => {
    if (p.$disabled) return '#fafafa'
    if (p.$selected) return '#eff6ff'
    return 'transparent'
}

const qTagBg = type => {
    if (type === 'skipped') return '#fee2e2'
    if (type === 'replace') return '#fef3c7'
    return '#d1fae5'
}

const qTagColor = type => {
    if (type === 'skipped') return '#991b1b'
    if (type === 'replace') return '#92400e'
    return '#065f46'
}

export const PageWrap = styled.div`
    margin: -1rem;
    min-height: calc(100vh - 55px);
    background: #f3f4f6;
    padding-bottom: 32px;
    box-sizing: border-box;
    max-width: 100%;
    overflow-x: hidden;

    @media (max-width: ${TABLET_BREAKPOINT}) {
        margin: -0.5rem -0.75rem;
        padding-bottom: 24px;
    }
`

export const PageContent = styled.div`
    max-width: 1100px;
    margin: 0 auto;
    padding: 20px 24px;
    width: 100%;
    min-width: 0;
    box-sizing: border-box;

    @media (max-width: ${TABLET_BREAKPOINT}) {
        padding: 16px 12px;
    }
`

export const Breadcrumb = styled.div`
    color: #6b7280;
    font-size: 13px;
    margin-bottom: 14px;

    a {
        color: #2563eb;
        text-decoration: none;
        cursor: pointer;

        &:hover {
            text-decoration: underline;
        }
    }
`

export const PageTitle = styled.h1`
    margin: 0 0 6px;
    font-size: 24px;
    font-weight: 600;
    color: #111827;
    word-break: break-word;

    @media (max-width: ${TABLET_BREAKPOINT}) {
        font-size: 20px;
    }
`

export const PageSubtitle = styled.p`
    margin: 0 0 18px;
    font-size: 14px;
    color: #374151;
    line-height: 1.5;
`

export const Card = styled.div`
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 24px 28px;
    margin-bottom: 18px;
`

export const TipCard = styled(Card)`
    background: #eff6ff;
    border-color: #bfdbfe;

    h2 {
        margin: 0 0 8px;
        font-size: 16px;
        color: #1e40af;
    }

    p {
        margin: 0;
        color: #1e3a8a;
        font-size: 14px;
        line-height: 1.55;
    }
`

export const SummaryStrip = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    margin-bottom: 16px;

    @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 480px) {
        grid-template-columns: 1fr;
    }
`

export const StatCard = styled.div`
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 14px 16px;
    border-left: 3px solid ${p => statBorderColor(p.$color)};
    cursor: ${p => (p.$clickable ? 'pointer' : 'default')};

    &:hover {
        ${p => (p.$clickable ? 'border-color: #f97316;' : '')}
    }

    .lbl {
        font-size: 11px;
        text-transform: uppercase;
        color: #6b7280;
        letter-spacing: 0.04em;
    }

    .val {
        font-size: 26px;
        font-weight: 700;
        margin-top: 2px;
        color: #111827;
    }

    .muted {
        font-size: 14px;
        color: #6b7280;
        font-weight: 400;
    }
`

export const ToolbarRow = styled.div`
    display: flex;
    gap: 8px;
    margin-bottom: 14px;
    align-items: center;
    flex-wrap: wrap;

    .spacer {
        flex: 1;
        min-width: 0;
    }

    @media (max-width: ${TABLET_BREAKPOINT}) {
        flex-direction: column;
        align-items: stretch;

        .spacer {
            display: none;
        }
    }
`

export const SearchInput = styled.input`
    padding: 8px 12px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    font-size: 14px;
    min-width: 0;
    flex: 1 1 240px;
    box-sizing: border-box;

    @media (max-width: ${TABLET_BREAKPOINT}) {
        width: 100%;
        flex: 1 1 100%;
    }
`

export const TicketCountText = styled.span`
    font-size: 13px;
    color: #6b7280;
    white-space: nowrap;
    flex-shrink: 0;

    @media (max-width: ${TABLET_BREAKPOINT}) {
        white-space: normal;
    }
`

export const TabBar = styled.div`
    display: flex;
    gap: 4px;
    margin-bottom: 16px;
    border-bottom: 1px solid #e5e7eb;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
`

export const TabButton = styled.button`
    border: none;
    background: transparent;
    padding: 10px 16px;
    font-size: 14px;
    font-weight: 600;
    color: ${p => (p.$active ? '#2563eb' : '#6b7280')};
    border-bottom: 2px solid
        ${p => (p.$active ? '#2563eb' : 'transparent')};
    margin-bottom: -1px;
    cursor: pointer;
    white-space: nowrap;
    flex-shrink: 0;

    &:hover {
        color: #2563eb;
    }

    @media (max-width: ${TABLET_BREAKPOINT}) {
        padding: 10px 12px;
        font-size: 13px;
    }
`

export const TicketTableWrap = styled.div`
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    overflow: hidden;
    max-width: 100%;
`

export const TicketTableScroll = styled.div`
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
`

export const TicketTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    min-width: 980px;

    th {
        text-align: left;
        padding: 10px 14px;
        background: #f9fafb;
        color: #6b7280;
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        border-bottom: 1px solid #e5e7eb;
        white-space: nowrap;
    }

    td {
        padding: 12px 14px;
        border-bottom: 1px solid #f3f4f6;
        color: #111827;
        vertical-align: top;
    }

    tr:last-child td {
        border-bottom: none;
    }

    tr:hover td {
        background: #f9fafb;
    }

    .title-cell {
        max-width: 420px;
        line-height: 1.45;
        word-break: break-word;
    }

    .mono {
        font-weight: 600;
        color: #2563eb;
        cursor: pointer;

        &:hover {
            text-decoration: underline;
        }
    }
`

export const TicketMobileList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 12px;
`

export const TicketMobileCard = styled.button`
    display: block;
    width: 100%;
    text-align: left;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 14px;
    cursor: pointer;
    font-family: inherit;
    box-sizing: border-box;

    &:hover {
        background: #f9fafb;
    }
`

export const TicketMobileTop = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 8px;
`

export const TicketMobileId = styled.span`
    font-size: 14px;
    font-weight: 700;
    color: #2563eb;
`

export const TicketMobileMeta = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
    margin-bottom: 8px;
`

export const TicketMobileTitle = styled.div`
    font-size: 13px;
    line-height: 1.45;
    color: #111827;
    word-break: break-word;
    margin-bottom: 8px;
`

export const TicketMobileFooter = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px 12px;
    font-size: 12px;
    color: #6b7280;

    @media (max-width: 400px) {
        grid-template-columns: 1fr;
    }

    .label {
        display: block;
        font-size: 10px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        color: #9ca3af;
        margin-bottom: 2px;
    }

    .value {
        color: #374151;
        word-break: break-word;
    }
`

export const TicketStatusPill = styled.span`
    display: inline-block;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.03em;
    background: ${p => p.$bg || '#f1f5f9'};
    color: ${p => p.$color || '#475569'};
`

export const TicketPriorityPill = styled.span`
    display: inline-block;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 700;
    background: ${p => p.$bg || '#fef3c7'};
    color: ${p => p.$color || '#92400e'};
`

export const RuleCardWrap = styled.div`
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 16px 20px;
    margin-bottom: 10px;
    border-left: 3px solid #8b5cf6;
    opacity: ${p => (p.$disabled ? 0.55 : 1)};
    background: ${p => (p.$disabled ? '#fafafa' : '#fff')};
`

export const RuleCardTop = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
`

export const RuleQuestion = styled.div`
    font-weight: 600;
    font-size: 14px;
    color: #111827;
`

export const RuleMeta = styled.div`
    font-size: 12px;
    color: #6b7280;
    margin-top: 3px;
`

export const StatusBadge = styled.span`
    display: inline-block;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    background: ${p => (p.$active ? '#d1fae5' : '#fee2e2')};
    color: ${p => (p.$active ? '#065f46' : '#991b1b')};
`

export const RuleSentence = styled.div`
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px dashed #e5e7eb;
    font-size: 13.5px;
    color: #374151;
    line-height: 1.7;

    b {
        color: #111827;
    }
`

export const PillTrigger = styled.span`
    background: #fee2e2;
    color: #991b1b;
    padding: 2px 8px;
    border-radius: 4px;
    font-weight: 600;
`

export const PillAssignee = styled.span`
    background: #dbeafe;
    color: #1e40af;
    padding: 2px 8px;
    border-radius: 4px;
    font-weight: 600;
`

export const PillCustomers = styled.span`
    display: inline-block;
    background: ${p => (p.$all ? '#e5e7eb' : '#dbeafe')};
    color: ${p => (p.$all ? '#374151' : '#1e40af')};
    padding: 2px 8px;
    border-radius: 4px;
    font-weight: 600;
`

export const PillPriority = styled.span`
    font-weight: 700;
    color: ${p => {
        if (p.$level === 'critical') return '#dc2626'
        if (p.$level === 'high') return '#f59e0b'
        if (p.$level === 'medium') return '#2563eb'
        return '#6b7280'
    }};
`

export const RuleActions = styled.div`
    margin-top: 10px;
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    flex-wrap: wrap;
    align-items: center;
`

export const ToggleWrap = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    margin-right: auto;
    font-size: 12px;
    color: #6b7280;
`

export const Switch = styled.label`
    position: relative;
    display: inline-block;
    width: 36px;
    height: 20px;

    input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        inset: 0;
        background: #d1d5db;
        border-radius: 999px;
        transition: 0.2s;

        &:before {
            content: '';
            position: absolute;
            height: 14px;
            width: 14px;
            left: 3px;
            top: 3px;
            background: #fff;
            border-radius: 50%;
            transition: 0.2s;
        }
    }

    input:checked + .slider {
        background: #10b981;
    }

    input:checked + .slider:before {
        transform: translateX(16px);
    }
`

export const AutoRulesBtn = styled.button`
    background: linear-gradient(180deg, #f5f3ff 0%, #ede9fe 100%);
    color: #6b21a8;
    border: 1px solid #d8b4fe;
    font-weight: 600;
    padding: 6px 10px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 12px;
    display: inline-flex;
    align-items: center;
    gap: 5px;

    &:hover {
        background: #ede9fe;
    }

    &:disabled {
        opacity: 0.6;
        cursor: wait;
    }
`

export const RuleCountBadge = styled.span`
    background: ${p => (p.$none ? '#d1d5db' : '#6b21a8')};
    color: ${p => (p.$none ? '#6b7280' : '#fff')};
    font-size: 10px;
    font-weight: 700;
    padding: 1px 6px;
    border-radius: 999px;
`

/* Wizard */
export const WizardStepper = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin: 18px 0 26px;
    padding: 0 8px;
    gap: 4px;

    @media (max-width: ${TABLET_BREAKPOINT}) {
        padding: 0;
    }
`

export const StepPip = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    position: relative;
    min-width: 0;

    .num {
        width: 36px;
        height: 36px;
        flex-shrink: 0;
        border-radius: 50%;
        background: ${p => stepNumBg(p)};
        color: ${p => (p.$active || p.$done ? '#fff' : '#6b7280')};
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 700;
        font-size: 14px;
        z-index: 2;
        border: 3px solid #f3f4f6;
    }

    .label {
        font-size: 11px;
        color: ${p => stepLabelColor(p)};
        margin-top: 6px;
        text-align: center;
        max-width: 96px;
        min-height: 32px;
        line-height: 1.35;
        font-weight: ${p => (p.$active ? 600 : 400)};
    }

    @media (max-width: ${TABLET_BREAKPOINT}) {
        .num {
            width: 28px;
            height: 28px;
            font-size: 12px;
        }

        .label {
            font-size: 10px;
            max-width: 72px;
        }

        &::after {
            top: 14px;
        }
    }

    &::after {
        content: '';
        position: absolute;
        top: 18px;
        left: 50%;
        right: -50%;
        height: 3px;
        background: ${p => (p.$done ? '#10b981' : '#e5e7eb')};
        z-index: 1;
    }

    &:last-child::after {
        display: none;
    }
`

export const WizardPanel = styled(Card)`
    min-height: 280px;

    h2 {
        color: #1d4ed8;
        margin: 0 0 12px;
        font-size: 18px;
    }
`

export const WhyBox = styled.div`
    background: #eff6ff;
    border-left: 3px solid #2563eb;
    padding: 10px 14px;
    border-radius: 6px;
    margin: 12px 0 20px;
    font-size: 13px;
    color: #1e40af;
    line-height: 1.5;
`

export const Field = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 18px;

    label {
        font-weight: 600;
        font-size: 14px;
        color: #111827;
    }

    .helper {
        font-size: 12px;
        color: #6b7280;
    }

    select,
    input,
    textarea {
        padding: 10px 12px;
        border: 1px solid #d1d5db;
        border-radius: 6px;
        font-size: 14px;
        background: #fff;
        max-width: 580px;
        font-family: inherit;

        &:focus {
            outline: none;
            border-color: #2563eb;
            box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
        }
    }

    textarea {
        resize: vertical;
        min-height: 70px;
        max-width: 100%;
    }
`

export const CustomerSearch = styled.input`
    width: 100%;
    max-width: 640px;
    margin-top: 14px;
    padding: 10px 12px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    font-size: 14px;
    font-family: inherit;
    background: #fff;

    &:focus {
        outline: none;
        border-color: #2563eb;
        box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
    }
`

export const CustomerScopeList = styled.div`
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    max-width: 640px;
    margin-top: 8px;
    overflow: hidden;
    background: #fff;
`

export const CustomerScopeToolbar = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border-bottom: 1px solid #e5e7eb;
    font-size: 12px;
    color: #6b7280;
    background: #f9fafb;

    button {
        background: none;
        border: 0;
        color: #2563eb;
        font-weight: 600;
        cursor: pointer;
        font-size: 12px;
        padding: 0;
    }
`

export const CustomerScopeRows = styled.div`
    max-height: 280px;
    overflow-y: auto;
`

export const CustomerScopeRow = styled.label`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    border-bottom: 1px solid #f3f4f6;
    cursor: pointer;
    font-size: 13.5px;
    background: ${p => (p.$checked ? '#eff6ff' : '#fff')};

    &:last-child {
        border-bottom: 0;
    }

    &:hover {
        background: #f8faff;
    }

    input {
        margin: 0;
    }

    .name {
        flex: 1;
        min-width: 0;
        color: #111827;
        font-weight: 500;
    }

    .id {
        color: #6b7280;
        font-variant-numeric: tabular-nums;
        font-size: 12px;
    }
`

export const CustomerChipRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    align-items: center;
    margin-top: 10px;
    max-width: 640px;
`

export const CustomerChip = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: #dbeafe;
    color: #1e40af;
    border-radius: 999px;
    padding: 4px 8px 4px 10px;
    font-size: 12px;
    font-weight: 600;

    button {
        border: 0;
        background: transparent;
        color: #1e40af;
        cursor: pointer;
        font-size: 14px;
        line-height: 1;
        padding: 0;
    }
`

export const CustomerSelectedCount = styled.span`
    font-size: 12px;
    color: #6b7280;
    font-weight: 600;
`

export const RadioGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-width: 640px;
`

export const RadioCard = styled.label`
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 12px 14px;
    border: 1px solid ${p => (p.$checked ? '#2563eb' : '#d1d5db')};
    border-radius: 8px;
    cursor: pointer;
    font-weight: 400;
    font-size: 13.5px;
    background: ${p => (p.$checked ? '#eff6ff' : '#fff')};

    &:hover {
        border-color: #2563eb;
        background: #f8faff;
    }

    input {
        margin-top: 3px;
    }

    .rtitle {
        font-weight: 600;
        color: #111827;
    }

    .rdesc {
        font-size: 12px;
        color: #6b7280;
        margin-top: 2px;
    }
`

export const UrgencyGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    max-width: 720px;

    @media (max-width: 640px) {
        grid-template-columns: repeat(2, 1fr);
    }
`

export const UrgCard = styled.div`
    border: 2px solid ${p => (p.$selected ? '#2563eb' : '#e5e7eb')};
    border-radius: 10px;
    padding: 14px 12px;
    text-align: center;
    cursor: pointer;
    background: ${p => (p.$selected ? '#eff6ff' : '#fff')};
    transition: 0.15s;

    &:hover {
        border-color: #93c5fd;
    }

    .icon {
        font-size: 26px;
        margin-bottom: 4px;
    }

    .name {
        font-weight: 700;
        font-size: 14px;
    }

    .sla {
        font-size: 11px;
        color: #6b7280;
        margin-top: 4px;
    }
`

export const WizardFooter = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 14px 0 0;
    flex-wrap: wrap;
    gap: 8px;

    .left,
    .right {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
    }
`

export const PreviewCard = styled.div`
    background: linear-gradient(180deg, #ecfdf5 0%, #d1fae5 100%);
    border: 1px solid #6ee7b7;
    border-left: 4px solid #10b981;
    border-radius: 10px;
    padding: 18px 22px;
    margin: 14px 0;

    h3 {
        margin: 0 0 8px;
        color: #065f46;
        font-size: 15px;
    }

    dl {
        display: grid;
        grid-template-columns: 160px 1fr;
        gap: 8px 14px;
        margin: 8px 0 0;
        font-size: 13.5px;

        @media (max-width: 500px) {
            grid-template-columns: 1fr;
        }
    }

    dt {
        color: #047857;
        font-weight: 600;
    }

    dd {
        margin: 0;
        color: #111827;
    }

    .ttl {
        background: #fff;
        padding: 10px 12px;
        border-radius: 6px;
        margin-top: 14px;
        font-family: ui-monospace, monospace;
        font-size: 13px;
        color: #064e3b;
    }
`

export const PickerInfo = styled.div`
    background: #f0f9ff;
    border: 1px solid #bae6fd;
    border-radius: 8px;
    padding: 10px 14px;
    margin-top: 8px;
    font-size: 12.5px;
    color: #075985;

    .pi-line {
        margin: 4px 0;

        b {
            color: #0c4a6e;
        }
    }
`

export const TwoCol = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    @media (max-width: 640px) {
        grid-template-columns: 1fr;
    }
`

/* Copy modal */
export const ModalBackdrop = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(17, 24, 39, 0.55);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 20px;
`

export const ModalBox = styled.div`
    background: #fff;
    border-radius: 12px;
    width: 760px;
    max-width: 100%;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
`

export const ModalHead = styled.div`
    padding: 18px 24px 14px;
    border-bottom: 1px solid #e5e7eb;

    h2 {
        margin: 0;
        font-size: 18px;
        color: #111827;
    }

    .m-sub {
        font-size: 13px;
        color: #6b7280;
        margin-top: 4px;
    }
`

export const ModalBody = styled.div`
    padding: 18px 24px;
    overflow-y: auto;
    flex: 1;
`

export const ModalFoot = styled.div`
    padding: 14px 24px;
    border-top: 1px solid #e5e7eb;
    background: #f9fafb;
    border-radius: 0 0 12px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;

    .count {
        font-size: 13px;
        color: #4b5563;

        b {
            color: #1d4ed8;
        }
    }

    .btns {
        display: flex;
        gap: 8px;
    }
`

export const SrcRule = styled.div`
    background: linear-gradient(180deg, #fef3c7 0%, #fde68a 100%);
    border: 1px solid #fbbf24;
    border-left: 4px solid #f59e0b;
    border-radius: 8px;
    padding: 12px 16px;
    margin-bottom: 16px;
    font-size: 13px;

    .src-label {
        font-size: 10px;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        color: #92400e;
        font-weight: 700;
        margin-bottom: 4px;
    }

    .src-sentence {
        color: #111827;
        line-height: 1.6;

        b {
            color: #92400e;
        }
    }
`

export const QSearch = styled.input`
    width: 100%;
    padding: 9px 12px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    font-size: 13px;
    margin-bottom: 14px;
`

export const SectGroup = styled.div`
    margin-bottom: 14px;
`

export const SectHead = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    background: #f3f4f6;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #374151;

    .sect-actions {
        font-size: 11px;
        color: #2563eb;
        cursor: pointer;
        font-weight: 600;

        &:hover {
            text-decoration: underline;
        }
    }
`

export const QPick = styled.label`
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 10px 12px;
    border-bottom: 1px solid #f9fafb;
    cursor: ${p => (p.$disabled ? 'not-allowed' : 'pointer')};
    background: ${p => qPickBg(p)};
    opacity: ${p => (p.$disabled ? 0.55 : 1)};

    &:hover {
        background: ${p => (p.$disabled ? '#fafafa' : '#f9fafb')};
    }

    input {
        width: 16px;
        height: 16px;
        margin-top: 2px;
        flex-shrink: 0;
    }

    .qq {
        font-size: 13.5px;
        font-weight: 600;
        color: #111827;
    }

    .qq-meta {
        font-size: 11px;
        color: #6b7280;
        margin-top: 3px;
    }
`

export const QTag = styled.span`
    display: inline-block;
    font-size: 10px;
    padding: 1px 7px;
    border-radius: 999px;
    margin-left: 6px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    vertical-align: middle;
    background: ${p => qTagBg(p.$type)};
    color: ${p => qTagColor(p.$type)};
`

export const ConflictRow = styled.div`
    background: #fefce8;
    border: 1px solid #fde68a;
    border-radius: 8px;
    padding: 12px 14px;
    margin-top: 16px;
    font-size: 13px;

    .ch-label {
        font-weight: 700;
        color: #92400e;
        margin-bottom: 6px;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        font-size: 11px;
    }

    .ch-opts {
        display: flex;
        gap: 14px;
        flex-wrap: wrap;

        label {
            display: flex;
            align-items: center;
            gap: 6px;
            cursor: pointer;
            color: #374151;
        }
    }
`

export const InlineVendorCard = styled.div`
    border: 1px solid #d1d5db;
    border-radius: 8px;
    background: #fff;
    padding: 16px 20px;
    margin: 12px 0 4px;
    max-width: 460px;

    .card-title {
        font-weight: 700;
        font-size: 14px;
        color: #111827;
        margin-bottom: 14px;
    }

    .field-error {
        color: #dc2626;
        font-size: 12px;
        margin-top: -6px;
        margin-bottom: 8px;
    }

    .form-row-2 {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;

        @media (max-width: 560px) {
            grid-template-columns: 1fr;
        }
    }

    .checkbox-row {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 4px;
        font-size: 13px;
        color: #374151;
    }

    .card-actions {
        display: flex;
        gap: 8px;
        justify-content: flex-end;
        margin-top: 14px;
    }
`

export const VendorManageActions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
    flex-wrap: wrap;

    .manage-label {
        font-size: 12px;
        color: #6b7280;
        margin-right: 4px;
    }

    .delete-warning {
        width: 100%;
        font-size: 12px;
        color: #b45309;
        margin-top: 2px;
    }
`

export const VendorDropdownStyles = styled.div`
    .ui.dropdown .menu .item.vendor-add-new-option {
        border-top: 1px solid #e5e7eb;
        color: #2563eb !important;
        font-weight: 600;
        margin-top: 4px;
        padding-top: 10px !important;
    }

    .ui.dropdown .menu .item.vendor-add-new-option:hover {
        background: #eff6ff !important;
    }
`
